import { useTranslation } from "react-i18next";
import { RowInfo, NubsUpload } from "../common";
import MediaSectionModal from "./modals/MediaSectionModal";
import { MediaForm } from "./MediaSection.style";
import { useDeleteNubMutation } from "./Nubs.state";

const MediaSection = ({ useQuery, id }) => {
    const { t } = useTranslation();

    return (
        <RowInfo colClassName="mb-4" help={<MediaSectionModal />} isFull>
            <MediaForm id={`form-${id}`} onSubmit={e => e.preventDefault()}>
                <NubsUpload 
                    label={t(`Game Description`)} 
                    useQuery={useQuery} 
                    useDeleteNubMutation={useDeleteNubMutation}
                />
            </MediaForm>
        </RowInfo>
    );
};

export default MediaSection;